<template>
  <div class="flex min-h-screen items-center justify-center bg-background p-4">
    <iframe name="hiddenFrame" id="hiddenFrame" style="display: none;"></iframe>

    <div class="w-full max-w-md rounded-xl border bg-card p-8 text-card-foreground shadow-xl">
      <div class="mb-8 flex items-center justify-between">
        <h1 class="text-3xl font-bold">Авторизация</h1>
        <button
          @click="toggleTheme"
          class="button button-outline !h-9 !w-9 !px-0"
          title="Переключить тему"
        >
          <svg v-if="!isDark" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
          </svg>
          <svg v-else class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
          </svg>
        </button>
      </div>
      
      <form ref="loginForm" @submit="login" method="post" target="hiddenFrame" action="/" class="space-y-5">
        <div>
          <label for="username" class="mb-2 block text-sm font-medium">Имя пользователя</label>
          <input
            type="text"
            id="username"
            name="username"
            autocomplete="username"
            placeholder="Введите имя пользователя"
            v-model="username"
            required
            class="input-field"
          />
        </div>

        <div>
          <label for="password" class="mb-2 block text-sm font-medium">Пароль</label>
          <input
            type="password"
            id="password"
            name="password"
            autocomplete="current-password"
            placeholder="Введите пароль"
            v-model="password"
            required
            class="input-field"
          />
        </div>

        <div v-if="error" class="rounded-md border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive">
          {{ error }}
        </div>

        <button
          type="submit"
          class="button w-full"
          :disabled="loading"
        >
          <span v-if="loading">Вход...</span>
          <span v-else>Войти</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { login as apiLogin } from '../services/api';
import { useToast } from 'vue-toastification';
import { useTheme } from '../utils/useTheme';
import { computed } from 'vue';

export default {
  name: 'LoginView',
  setup() {
    const toast = useToast();
    const { currentTheme, toggleTheme: toggleThemeFunc } = useTheme();
    const isDark = computed(() => currentTheme.value === 'dark');
    
    return { 
      toast,
      isDark,
      toggleTheme: toggleThemeFunc
    };
  },
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: ''
    };
  },
  methods: {
    async login(event) {
      event.preventDefault();
      
      this.loading = true;
      this.error = '';
      
      try {
        const data = await apiLogin(this.username, this.password);
        
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        
        this.loading = false;
        this.toast.success('Вход выполнен успешно');
        
        const dummyForm = document.createElement('form');
        dummyForm.method = 'POST';
        dummyForm.action = '/';
        dummyForm.target = 'hiddenFrame';
        
        const usernameInput = document.createElement('input');
        usernameInput.type = 'text';
        usernameInput.name = 'username';
        usernameInput.autocomplete = 'username';
        usernameInput.value = this.username;
        
        const passwordInput = document.createElement('input');
        passwordInput.type = 'password';
        passwordInput.name = 'password';
        passwordInput.autocomplete = 'current-password';
        passwordInput.value = this.password;
        
        dummyForm.appendChild(usernameInput);
        dummyForm.appendChild(passwordInput);
        
        document.body.appendChild(dummyForm);
        dummyForm.submit();
        
        setTimeout(() => {
          document.body.removeChild(dummyForm);
        }, 100);
        
        setTimeout(() => {
          this.$router.push('/');
        }, 300);
        
      } catch (error) {
        console.error('Ошибка авторизации:', error.message);
        this.error = 'Неверное имя пользователя или пароль';
        this.toast.error('Ошибка авторизации');
        this.loading = false;
      }
    }
  }
}
</script>
